module.exports = __webpack_public_path__ + "img/image-ad-transparent.0d279198.png";